export const STEPS = ['core', 'support', 'styling', 'accessories', 'review'];

export const STEPS_TITLE = {
  core: 'Core',
  support: 'Support',
  styling: 'Styling',
  accessories: 'Accessories',
  review: 'Review',
};

export const STEPS_PAGE_TITLES = {
  core: 'CORE COMPONENTS',
  support: 'COOLING AND STORAGE',
  styling: 'DESIGN AND AESTHETICS',
  accessories: 'ACCESSORIES AND GEAR',
  review: 'REVIEW',
  build: 'CREATE YOUR DREAM RIG',
  chassis: 'CREATE YOUR DREAM RIG',
};
